module.exports = __webpack_public_path__ + "img/back_buttons_quantity.ca71fce7.png";